module.exports = __webpack_public_path__ + "static/media/md-arrow-round-up.a52337f9.svg";